import { getMsalSimDocumentsInstance, getMsalSimInstance, getSilentSimDocumentsRequest, getSilentSimRequest } from "./authConfig";

export const fetchSimDocumentsToken = async () => {
    const account = getMsalSimInstance().getAllAccounts()[0];
    if (account) {
        const tokenResponse = await getMsalSimDocumentsInstance().acquireTokenSilent(getSilentSimDocumentsRequest(account));
        const token = tokenResponse.accessToken;
        return token;
    }
    
}; 

export const fetchSimToken = async () => {
    const account = getMsalSimInstance().getAllAccounts()[0];
    if (account) {
        const tokenResponse = await getMsalSimInstance().acquireTokenSilent(getSilentSimRequest(account));
        const token = tokenResponse.accessToken;
        return token;
    }
};